import moment from "moment"

moment.locale('pt-br')

const timeHelper = {

  weekdayFromDatetime: datetime => moment(datetime).format('dddd'),
  weekdayNumber: datetime => moment(datetime).weekday(),
  hourFromDatetime: datetime => moment(datetime).format('HH:mm'),
  date: datetime => moment(datetime).format('LL'),
  dateIsAfter: (d1, d2) => moment(d1).isAfter(moment(d2)),
  timeIsAfter: (t1, t2) => moment(t1, 'HH:mm').isAfter(moment(t2, 'HH:mm')),
  dateIsSame: (d1, d2) => moment(d1).isSame(d2, 'day'),
  dateIsBetween: (d, start, end) => moment(d).isBetween(start, end, null, '[]'),
  weekDatesByPage: page => {
    const dates = []
    for (let i = 0; i <= 6; i++) {
      const d = moment().startOf('day').add(page, 'weeks').add(i, 'days')
      dates.push({
        year: d.year(), month: d.month(), day: d.date(), date: d.format()
      })
    }
    return dates
  },
  dateIndex: datetime => moment(datetime).format('YYYY-MM-DD'),
  timeIndex30min: datetime => {
    const t = moment(datetime).startOf('hour')
    if (t.diff(datetime, 'minutes') <= -30) t.add(30, 'minutes')
    return t.format('HH:mm')
  },
  minutesFromTimeSpan: (start, end, isEndDateEnd) => moment(isEndDateEnd ? moment(end).add(1, 'day') : end).diff(start, 'minutes'),
  datesBetween: (start, end) => {
    const dates = []
    const startDate = moment(start)
    while(startDate.isSameOrBefore(end)) {
      dates.push(startDate.clone().format('YYYY-MM-DD'))
      startDate.add(1, 'days')
    }
    return dates
  },

  hourFromMinutes: minutes => moment('00', 'HH').minutes(minutes).format('HH:mm'),
  dayAndMonth: (day, month) => moment({ day, month }).format('DD/MM'),
  timeAndDateFromDateTime: datetime => moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('HH:mm - DD/MM/YYYY'),
  dateFromDateTime: datetime => moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY'),
  minutesBeforeTime : (datetime, minutes) => moment(datetime).subtract(minutes, 'minutes')
}

export default timeHelper



// WEBPACK FOOTER //
// ./src/lib/timeHelper.js